<template>
    <section id="content" v-if="result">

        <div class="home__intro intro__area background-image-holder">

            <div class="wrapper">
                <!-- <h1 class="animated-heading"  data-gsap-stagger="0.2" data-gsap-delay="0" data-gsap-duration = "0.8" v-html="result.home.data.attributes.Intro.Intro.Title"></h1> -->
                <h1 v-html="result.home.data.attributes.Intro.Intro.Title"
                    class="animated-heading"
                    data-gsap-type="chars" 
                    data-gsap-duration="0.3" 
                    data-gsap-stagger="0.04"
                    data-gsap-distance="50"
                    data-gsap-initial-scale="0.7" ></h1>
            </div>

            <div class="small-wrapper">
                <!-- <p class="animated-heading" v-html="result.home.data.attributes.Intro.Intro.Description" data-gsap-type="lines" data-gsap-delay="0.8" data-gsap-duration = "0.7"></p> -->
                <p v-html="result.home.data.attributes.Intro.Intro.Description"
                    class="animated-heading"
                    data-gsap-type="lines" 
                    data-gsap-start="top 80%" 
                    data-gsap-end="bottom center" 
                    data-gsap-delay="0.42"
                    data-gsap-distance="50"></p>
            </div>

            <router-link class="badge-button" v-if="result.home.data.attributes.Intro.Button.label && result.home.data.attributes.Intro.Button.href" :to="result.home.data.attributes.Intro.Button.href"
                        data-gsap="fadeIn" data-gsap-delay="0.3" data-gsap-duration="1" data-gsap-ease="none">
                <span class="badge-button__content">
                    {{ result.home.data.attributes.Intro.Button.label }}
                    <div class="badge-button__icon">
                        <long-arrow/>
                    </div>
                </span>
                <span class="badge-button__rain rotate-badge">
                    <badge-icon/>
                </span>
            </router-link>

            <div class="scroll-more-holder" data-gsap="fadeIn" data-gsap-delay="0.3" data-gsap-duration="1" data-gsap-ease="none" data-gsap-start="top 100%">
                <p> Scroll for more</p>
            </div>
            

            <span class="hero-shape-1"></span>
            <span class="hero-shape-2"></span>
            <span class="hero-shape-3"></span>
            <hero-shape-4/>
            <hero-shape-7/>
            <span class="hero-noise"></span>
            <span class="hero-shape-5"></span>
            <span class="hero-shape-6"></span>

        </div>

        <div class="home__services marquee__holder">

            <div class="home__services__holder small-wrapper">
                <div class="section__intro__holder">
                    <intro-component :intro="result.home.data.attributes.Services.Intro" :index="1"></intro-component>
                    <!-- <router-link  class="general-button"
                        v-if="result.home.data.attributes.Services.Button.label && result.home.data.attributes.Services.Button.href"
                        :to="result.home.data.attributes.Services.Button.href"
                        data-gsap="fromStartEnd" data-gsap-start="top 80%" data-gsap-end="bottom center" data-gsap-delay="0.45"
                        ></router-link> -->
                    <router-link  class="general-button"
                        v-if="result.home.data.attributes.Services.Button.label && result.home.data.attributes.Services.Button.href"
                        :to="result.home.data.attributes.Services.Button.href">
                            {{ result.home.data.attributes.Services.Button.label }}
                    </router-link>
                </div>

                <!-- <div class="accordions__holder animated-heading" data-gsap-type="lines" data-gsap-start="top 80%" data-gsap-end="bottom center" data-gsap-delay="1.2"> -->
                <div class="accordions__holder">
                    <div v-for="(accordion, index) in result.home.data.attributes.Services.Accortions">
                        <accordion-component  :key="index" :accordion="accordion" :index="index" :isOpen="openAccordionIndex === index" @toggle="toggleAccordion"></accordion-component>
                    </div>
                </div>
            </div>

            <div class="marquee">
                Analysis/Web/Marketing/Consulting/Analysis/Web/Marketing/Consulting/Analysis/Web/Marketing/Consulting/Analysis/Web/Marketing/Consulting/Analysis/Web/Marketing/Consulting/
            </div>
        </div>

        <div class="home__clients background-image-holder">
            <div class="small-wrapper">
                <intro-component :intro="result.home.data.attributes.OurClients.Intro" :index="2"></intro-component>
            </div>
            <div class="wrapper">
                <flickity ref="flickity" :options="flickityOptions" @flickityStaticClick="toggleClient">
                    <div v-for="(client, index) in result.home.data.attributes.OurClients.Clients">
                        <client-block
                            :key="index"
                            :client="{
                                name: client.Name,
                                info: client.Info,
                                url: client.Image?.data?.attributes?.url || null,
                                alternativeText: client.Image?.data?.attributes?.alternativeText || client.Name,
                                Image: client.Image
                            }"
                            :index="index"
                            :isActive="openClientIndex === index"
                            :isVisible="true"
                            :disableLazyLoading="true"
                            @toggle="toggleClient"                           
                        ></client-block>
                    </div>
                </flickity>
            </div>

            <span class="clients-noise"></span>

            <span class="clients-section-background">
            </span>
        </div>

        <div class="home__work marquee__holder">
            <div class="small-wrapper">
                <div class="grid two">
                    <intro-component :intro="result.home.data.attributes.SelectedWork.Intro" :index="3"></intro-component>
                </div>
            </div>
            <div class="wrapper">
                <div class="home__work__holder">
                    <div class="case-study__block" v-for="(study, index) in result.home.data.attributes.SelectedWork.case_studies.data">
                        <div class="case-study__index index__holder" data-gsap="fromStartEnd" data-gsap-delay="0.2">0{{index+1}}.</div>
                        <case-study :study="{
                                title: study.attributes.Title,
                                caption: study.attributes.caption,
                                slug: `/case-studies/${study.attributes.slug}`,
                                url: study.attributes.FeaturedImage?.data?.attributes?.url || null,
                                alternativeText: study.attributes.FeaturedImage?.data?.attributes?.alternativeText || study.attributes.Title,
                                id: study.id,
                                FeaturedImage: study.attributes.FeaturedImage
                            }"
                            data-gsap="divPopin"
                            data-gsap-delay="0"
                            data-gsap-duration="0.6">
                        </case-study>
                    </div>
                </div>
                <!-- <button-component  :button="result.home.data.attributes.SelectedWork.Button" classes="main-accent" data-gsap="fromStartEnd" data-gsap-delay="0.2"></button-component> -->
                <button-component  :button="result.home.data.attributes.SelectedWork.Button" classes="main-accent"></button-component>
            </div>

            <div class="marquee">
                Analysis/Web/Marketing/Consulting/Analysis/Web/Marketing/Consulting/Analysis/Web/Marketing/Consulting/Analysis/Web/Marketing/Consulting/Analysis/Web/Marketing/Consulting/
            </div>
        </div>

        <div class="home__touch marquee__holder background-image-holder">
            <div class="wrapper">

                <intro-component :intro="result.home.data.attributes.GetInTouch.Intro" :index="4" :isAnimated="true"></intro-component>

                <contact-form 
                    type="general"
                    gsap-animation="fadeIn"
                    gsap-delay="0.3"
                    gsap-duration="0.2"
                    gsap-ease="none">
                </contact-form>

            </div>
            <div class="marquee">
                Work with us/Work with us/Work with us/Work with us/Work with us/Work with us/Work with us/Work with us/Work with us/Work with us/Work with us/Work with us/
            </div>

            <span class="contact-shape1"></span>
            <!-- <span class="contact-shape2"></span>
            <span class="contact-shape3">
                <contact-quitar/>
            </span>
            <span class="contact-square">
                <contact-squares/>
            </span>
            <span class="contact-shape4"></span> -->
            <span class="contact-noise"></span>
        </div>

        <Seo :seoData="result.home.data.attributes.Seo"/>

    </section>
</template>

<script lang="ts">

import { defineComponent, ref, watch, onMounted } from 'vue'
import gql from 'graphql-tag'
import axios from 'axios'

import { useQuery } from '@vue/apollo-composable'
import { HOME_QUERY } from '../graphql/home'
import { useHead } from 'unhead'
import { gsap } from "gsap";


import ContactForm from '../components/ContactForm.vue';
import IntroComponent from '../components/IntroComponent.vue'
import ButtonComponent from '../components/ButtonComponent.vue'

import AccordionComponent from '../components/AccordionComponent.vue'
import ClientBlock from '../template-parts/clients/ClientBlock.vue'
import CaseStudy from '../template-parts/case-studies/CaseStudyBlock.vue'
import Flickity from '../components/Flickity.vue'
import LongArrow from "../components/svg/LongArrow.vue"
import BadgeIcon from "../components/svg/BadgeIcon.vue"
import ScrollMore from "../components/svg/ScrollMore.vue"
import Seo from '../components/navigation/Seo.vue'

import HeroShape4           from "../components/svg/HeroShape_4.vue"
import HeroShape7           from "../components/svg/HeroShape_7.vue"
import HeroCircles          from "../components/svg/HeroCircles.vue"
import ContactSquares          from "../components/svg/ContactSquares.vue"
import ContactQuitar          from "../components/svg/ContactQuitar.vue"
import ClientsSquares          from "../components/svg/ClientsSquares.vue"
import ClientsSection          from "../components/svg/ClientsSesction.vue"
export default defineComponent({
    components: {
        ButtonComponent,
        IntroComponent,
        AccordionComponent,
        CaseStudy,
        ContactForm,
        ClientBlock,
        Flickity,
        LongArrow,
        BadgeIcon,
        Seo,
        HeroShape4,
        HeroShape7,
        HeroCircles,
        ContactSquares,
        ContactQuitar,
        ClientsSquares,
        ClientsSection,
        ScrollMore,
    },
    data() {
        return {
            flickityOptions: {
                pageDots: false,
                groupCells: true,
                contain: true,
                prevNextButtons: false,
            }
        }
    },

    setup() {
        const homeurl: string = import.meta.env.VITE_API_URL

        const home_query = ref(HOME_QUERY)

        const openAccordionIndex = ref(0);
        const openClientIndex = ref(-1);

        function toggleAccordion(index: number) {
            openAccordionIndex.value =
            openAccordionIndex.value === index ? -1 : index;
        }

        function toggleClient(index: number) {
            openClientIndex.value =
            openClientIndex.value === index ? -1 : index;
        }

        onMounted(() => {
            setTimeout(() => {
                   // console.log('here?')
                const accordions = document.querySelectorAll('.accordion-item');
                accordions.forEach(accordion => {
                    const liElements = accordion.querySelectorAll('li');
                    liElements.forEach(liElement => {
                        if (liElement.querySelector('ul')) {
                            liElement.classList.add('has-child-ul');
                        }
                    });
                });
            }, 1000);
        });

        const { result } = useQuery(home_query)

        return {
            result,
            openAccordionIndex,
            toggleAccordion,
            toggleClient,
            openClientIndex
        }
    }

})
</script>
